import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClassificationHourActivityChartComponent } from './classification-hour-activity-chart.component';
import { ChartConfigService } from 'src/app/utils/chart/chart-config.service';
import { ToastrModule } from 'ngx-toastr'; // Import ToastrModule if ToastrService is used

@NgModule({
  declarations: [
    ClassificationHourActivityChartComponent  // Declare the ClassificationHourActivityChartComponent
  ],
  imports: [
    CommonModule,                  // Import necessary Angular modules
    ToastrModule.forRoot()         // Include ToastrModule if ToastrService is used
  ],
  providers: [
    ChartConfigService             // Provide the ChartConfigService for dependency injection
  ],
  exports: [
    ClassificationHourActivityChartComponent // Export the ClassificationHourActivityChartComponent for use in other modules
  ]
})
export class ClassificationHourActivityChartModule { }
